import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { ThemeProvider } from "./shared/contexts/ThemeContext";
import "./shared/i18n/i18n"; // initialize i18next

// ── Instalación de la PWA ────────────────────────────────────────────────────
// El navegador dispara `beforeinstallprompt` apenas carga la página, casi
// siempre ANTES de que React monte el botón de instalar. Si solo lo escuchara
// el componente, el evento ya habría pasado y el botón nunca aparecería (por
// eso no salía en escritorio). Se captura acá, lo más temprano posible, se
// guarda en window y se re-emite para que el componente lo tome esté montado
// o no.
window.__promptInstalacion = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__promptInstalacion = e;
  window.dispatchEvent(new Event("pwa:instalable"));
});
window.addEventListener("appinstalled", () => {
  window.__promptInstalacion = null;
  // Queda registrado para poder mostrar "Instalada" aunque después abran la
  // app desde una pestaña normal del navegador.
  try { localStorage.setItem("pwa_instalada", "true"); } catch { /* modo privado */ }
  window.dispatchEvent(new Event("pwa:instalada"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// ── Service worker (PWA) ─────────────────────────────────────────────────────
// Habilita instalar la app en el celular y que siga abriendo sin señal.
// Solo en producción: en `npm start` un SW interfiere con el hot reload.
// La estrategia es network-first (ver public/sw.js), así que no interfiere con
// el aviso de versión nueva.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // updateViaCache:"none" — el navegador nunca sirve sw.js desde su caché
    // HTTP, así que una versión nueva del service worker siempre se detecta.
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" })
      .then((reg) => { reg.update(); })
      .catch(() => {
        // Sin SW la app funciona igual, solo no es instalable.
      });
  });
}
